export const LOADING_TIPO_CRITICIDAD = "LOADING_TIPO_CRITICIDAD";
export const SAVE_LOADING_TIPO_CRITICIDAD = "SAVE_LOADING_TIPO_CRITICIDAD";
export const GET_TIPO_CRITICIDAD = "GET_TIPO_CRITICIDAD";
export const FORM_FAIL = "FORM_FAIL";
export const TIPO_CRITICIDAD_FAIL = "TIPO_CRITICIDAD_FAIL";
